<div class="row">
	<div class="col-lg-6">
		<div class="mb-3">
			<label>Create from Template:</label>
			<select [(ngModel)]="selectedTemplate" [disabled]="assetconfig" (ngModelChange)="templateChange($event)" class="form-control">
				@for (template of templates; track template) {
					<option [ngValue]="template">{{template.description}}</option>
				}
			</select>
			@if (loaderrormessage) {
				<div class="message-bad">{{loaderrormessage}}</div>
			}
		</div>
	</div>
</div>
@if (userinputgroups && !assetconfig) {
	<div class="row">
		<div class="col-lg-8">
			@for (section of userinputgroups; track section) {
				<div class="panel">
					@if (section.description) {
						<div class="heading">{{section.description}}</div>
					}
					<div class="content">
						@for (token of section.tokens; track token) {
							<div class="row token-input">
								<div class="col-sm-6">
									<label>{{token.description}}</label>
								</div>
								<div class="col-sm-6">
									@if (token.type === 'string') {
										<input [(ngModel)]="token.value" type="text" maxlength="50" class="form-control token-string">
									}
									@if (token.type === 'stringempty') {
										<input [(ngModel)]="token.value" type="text" maxlength="50" class="form-control token-stringempty">
									}
									@if (token.type === 'number') {
										<input [(ngModel)]="token.value" type="number" step="any" class="form-control token-number">
									}
									@if (token.type === 'int') {
										<input [(ngModel)]="token.value" type="number" step="1" class="form-control token-int">
									}
									@if (token.type === 'period') {
										<input [(ngModel)]="token.value" type="text" pattern="\d*[MH]" class="form-control token-period">
									}
									@if (token.type === 'ver') {
										<input [(ngModel)]="token.value" type="text" pattern="\d*\.\d*\.\d*" class="form-control token-ver">
									}
									@if (token.type === 'sampcode') {
										<select [(ngModel)]="token.value" class="form-control token-sampcode">
											@for (code of token.allowedCodes; track code) {
												<option>{{code}}</option>
											}
										</select>
									}
								</div>
							</div>
						}
					</div>
				</div>
			}
		</div>
	</div>
	<div class="row">
		<div class="col-lg-8">
			<app-action-button [action]="GenerateConfig" [context]="this" processing="Generating..." complete="Config added">Generate
				asset config</app-action-button>
		</div>
	</div>
}
@if (assetconfig) {
	<div class="row">
		<div class="col-lg-8">
			<label>XML configuration result:</label>
			<textarea [(ngModel)]="assetconfig" class="form-control" style="min-height: 800px;"></textarea>
		</div>
	</div>
	<div class="row mt-3">
		<div class="col-lg-8">
			<div class="mb-3">
				<label>Organization to assign configuration to:</label>
				<select [(ngModel)]="selectedOrganization" class="form-control">
					@for (org of organizations; track org) {
						<option [ngValue]="org">{{org.name}}</option>
					}
				</select>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-lg-8">
			<div class="row">
				<div class="col-sm-6 col-lg-5 col-xl-4">
					<div class="mb-3">
						<button (click)="GoBack()" class="button block">&lt; Go back</button>
					</div>
				</div>
				<div class="col-sm-6 col-lg-5 offset-lg-2 col-xl-4 offset-xl-4">
					<app-action-button [action]="SaveConfig" [disabled]="!selectedOrganization" [context]="this" processing="Saving..." complete="Config saved" btnClass="green block">Save to
						new asset config</app-action-button>
				</div>
			</div>
		</div>
	</div>
}